import React from "react";

const SummaryPage = ({ token, title }) => {
  return (
    <React.Fragment>
      <h2>Dziękujemy za zgłoszenie do konkursu Dyrektor e-Commerce Roku 2021</h2>
      <p>
        W chwili obecnej zgłoszenie oczekuje na preselekcję formalną. W
        przypadku jakichkolwiek nieprawidłowości skontaktujemy się z Państwem. O
        fakcie przejścia preselekcji formalnej poinformujemy mailowo, następne
        zgłoszenie zostanie poddane głosowaniu Jury Konkursu.
      </p>
      <p>
        Ważne! Zgłoszenie jest ważne po uiszczeniu opłaty za fakturę, która w
        najbliższych dniach zostanie wysłana przez organizatora. W przypadku
        jakichkolwiek pytań prosimy o kontakt:{" "}
        <a href="mailto:paulina.wojczynska@eizba.pl">
          paulina.wojczynska@eizba.pl
        </a>
      </p>

      <p>
        Z poważaniem,
        <br />
        Organizator konkursu Dyrektor e-Commerce Roku 2021
      </p>
      {token && (
        <p>
          Kod zgłoszenia: <strong>{token}</strong>
        </p>
      )}
    </React.Fragment>
  );
};

export default SummaryPage;
